import { ReactNode } from "react";
import { TranslationService } from "../../../../../services/TranslationService";
import { AIBillingErrorKind } from "../../../../../services/AIBillingService";
import Loading from "../../../../shared/components/Loading";
import Empty from "../../../../shared/components/Empty";
import ErrorMessage from "../../../../shared/components/Error";

export const AIBillingForbiddenBlock = () => (
  <div className="h-50 d-flex align-items-center justify-content-center">
    <div className="messageSwichContent text-center">
      <p className="mb-2">
        <i className="fal fa-lock-alt fa-3x" />
      </p>
      <p className="lead">
        {TranslationService.translate.AINoPermissionToView}
      </p>
    </div>
  </div>
);

const AIBillingStateBlock = ({
  loading,
  error,
  isEmpty,
  onRetry,
  errorMessage,
  emptyMessage,
  height = 200,
  children
}: {
  loading: boolean;
  error: AIBillingErrorKind;
  isEmpty?: boolean;
  onRetry: () => void;
  errorMessage?: string;
  emptyMessage?: string;
  height?: number;
  children: ReactNode;
}) => {
  const { translate } = TranslationService;

  if (loading) {
    return <Loading height={height} />;
  }
  if (error === "forbidden") {
    return <AIBillingForbiddenBlock />;
  }
  if (error === "generic") {
    return (
      <ErrorMessage
        message={errorMessage ?? translate.ErrorLoadingData}
        onRefresh={onRetry}
      />
    );
  }
  if (isEmpty) {
    return <Empty message={emptyMessage} />;
  }
  return <>{children}</>;
};

export default AIBillingStateBlock;
